<script setup lang="ts">
import Enums from '@/Enums';
import { systemUser } from '@/main-store';
const statuses = [Enums.SubscriptionStatus.Suspended, Enums.SubscriptionStatus.PastDue];
</script>
<template>
    <div class="pt-2 px-6" v-if="statuses.includes(systemUser?.clinic?.subscriptionStatus)">
        <div class="alert alert-danger text-center m-0"
            v-if="systemUser?.clinic?.subscriptionStatus == Enums.SubscriptionStatus.PastDue">
            <i class="fas fa-exclamation-triangle"></i>
            Your clinic's subscription payment is past due, please go to <router-link to="/billing">Organization &
                Billing</router-link> to resolve the issue and avoid interruption of service.
        </div>
        <div class="alert alert-danger text-center m-0"
            v-if="systemUser?.clinic?.subscriptionStatus == Enums.SubscriptionStatus.Suspended">
            <i class="fas fa-exclamation-triangle"></i>
            Your clinic subscription has been <strong>suspended</strong>! In order to resume service you need to update
            your credit card.
        </div>
    </div>
</template>